import { writable } from "svelte/store";

export const sidebarOpen = writable(false);
export const paletteOpen = writable(false);

// Per-user state (localStorage). Keep keys namespaced so they don't clash with
// the CRM if both are opened in the same browser.
const FAV_KEY = "lgp-playbook:favourites";
const READ_KEY = "lgp-playbook:read";

function loadSet(key: string): Set<string> {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return new Set();
    const arr = JSON.parse(raw);
    return new Set(Array.isArray(arr) ? arr : []);
  } catch {
    return new Set();
  }
}

function saveSet(key: string, value: Set<string>) {
  try {
    localStorage.setItem(key, JSON.stringify(Array.from(value)));
  } catch {
    /* ignore quota / private mode */
  }
}

function persistedSet(key: string) {
  const initial = typeof localStorage !== "undefined" ? loadSet(key) : new Set<string>();
  const store = writable(initial);
  store.subscribe((v) => {
    if (typeof localStorage !== "undefined") saveSet(key, v);
  });
  return {
    subscribe: store.subscribe,
    add: (slug: string) =>
      store.update((s) => {
        s.add(slug);
        return s;
      }),
    remove: (slug: string) =>
      store.update((s) => {
        s.delete(slug);
        return s;
      }),
    toggle: (slug: string) =>
      store.update((s) => {
        if (s.has(slug)) s.delete(slug);
        else s.add(slug);
        return s;
      }),
    has: (slug: string) => {
      let curr = new Set<string>();
      const unsub = store.subscribe((v) => (curr = v));
      unsub();
      return curr.has(slug);
    },
  };
}

export const favourites = persistedSet(FAV_KEY);
export const readSet = persistedSet(READ_KEY);
